var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_c('router-link',{staticClass:"myButton title mb-10",attrs:{"text":"","to":_vm.to}},[_c('v-icon',{staticClass:"icon mr-5"},[_vm._v(" mdi-arrow-left ")]),_vm._v(_vm._s(_vm.title))],1)],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }